import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IPayroll, IPayrollDeductions } from '@shared/models';
import { RequestsService } from '@shared/providers/external/requests.service';
import { LoaderService } from '@shared/providers/utilities/loader.service';

@Component({
    selector: 'anp-payment-flyer-details',
    templateUrl: './payment-flyer-details.component.html',
    styleUrls: ['./payment-flyer-details.component.scss'],
    standalone: false
})
export class PaymentFlyerDetailsComponent implements OnInit {
  public payrollDetails: IPayrollDeductions;
  public SumDeduccion: number = 0;
  public SumIncomes: number = 0;
  public Total: number = 0;
  public selectTabs = 'Ingresos';
  @Input() public payroll: IPayroll;
  constructor(
    private modalCtrl: ModalController,
    private requestService: RequestsService,
    private loaderService: LoaderService
  ) {}

  ngOnInit() {
    this.getPayrollDeductions(this.payroll.idNomina);
  }

  public onDismiss(): void {
    this.modalCtrl.dismiss();
  }

  //getting deductions from endpoint
  public async getPayrollDeductions(idNomina: number) {
    const loader = await this.loaderService.simpleLoader();
    try {
      const resp = await this.requestService.getPayRollDeductions(idNomina);
      this.payrollDetails = resp.Data;
      await loader.dismiss();
      //Sum of deductions
      this.payrollDetails.lstDeducciones.forEach((c) => {
        this.SumDeduccion += c.deduccion;
      });
      //Sum of Salary
      this.payrollDetails.lstSueldoNeto.forEach((c) => {
        this.SumIncomes += c.ingreso;
      });
      //General Total
      this.Total = this.SumIncomes - this.SumDeduccion;
    } catch (error) {
      await loader.dismiss();
      console.error(error);
    }
  }
}
